
class Poll {
    constructor({id, question, pollValues, pollVotes, author, createdAt, updatedAt, deletedAt, pollType, pollOptions}) {
        this.id = id;
        this.question = question;
        this.pollValues = pollValues;
        this.pollVotes = pollVotes;
        this.author = author;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.deletedAt = deletedAt;
        this.pollType = pollType;
        this.pollOptions = pollOptions;
    }

    getPollType() {
        return this.pollType;
    }

    get() {
        return {
            question: this.question,
            pollValues: this.pollValues.map(value => value.get()),
            pollType: this.pollType,
        }
    }

    static fromAPI(data) {
        if (!data) return null;
        
        return new Poll({
            id: data.id,
            question: data.question,
            pollValues: (data.pollValues || []).map(value => PollValue.fromAPI(value)),
            pollVotes: (data.pollVotes || []).map(vote => PollVote.fromAPI(vote)),
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
            pollType: data.pollType || data.postType || 'single'
        });
    }
}

export class PollValue {
    constructor({id, value}) {
        this.id = id;
        this.value = value;
    }

    get() {
        return {
            value: this.value,
        }
    }

    static fromAPI(data) {
        return new PollValue({
            id: data.id,
            value: data.value,
        });
    }

    static fromObject(data) {
        return new PollValue({
            id: data.id,
            value: data.value,
        });
    }
}

export class PollVote {
    constructor({id, pollId, userId, pollValueId}) {
        this.id = id;
        this.pollId = pollId;
        this.userId = userId;
        this.pollValueId = pollValueId;
    }

    get() {
        return {
            pollId: this.pollId,
            userId: this.userId,
            pollValueId: this.pollValueId,
        }
    }

    static fromAPI(data) {
        return new PollVote({
            id: data.id,
            pollId: data.pollId,
            userId: data.userId,
            pollValueId: data.pollValueId,
        });
    }

    static fromObject(data) {
        return new PollVote({
            id: data.id,
            pollId: data.pollId,
            userId: data.userId,
            pollValueId: data.pollValueId,
        });
    }
}

export default Poll;
